import { render, staticRenderFns } from "./UploadGroupModal.vue?vue&type=template&id=53e7504e&scoped=true&"
import script from "./UploadGroupModal.vue?vue&type=script&lang=js&"
export * from "./UploadGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=53e7504e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e7504e",
  null
  
)

export default component.exports